<template>
  <vjs-modal :name="name"
             title="Analytics Help"
             icon="la la-question-circle"
             width="900">
    <template slot="body-content">
      <div class="row">
        <div class="col-12">
          <p v-if="customer_too_new">
            As a new Timbre user, you do not have any valid analytics. Analytics highlights will become available after
            the <strong>1st of {{ next_month }}</strong>. Once you have published your first {{ getItemLabel(true) }}, analytics
            will be immediately available in <a :href="radar_base_url" target="_blank">Radar</a>.
          </p>
          <p v-if="!customer_too_new">
            Top Device, Top Region, Top {{ getFeedLabel(true) }} and Top {{ getItemLabel(true) }}
            are determined by <strong>Last Month's</strong> unique users. Full analytics can be accessed via <a href="https://radar.sharp-stream.com/sharpstream/podcasts" target="_blank">Radar</a>.
          </p>
          <p>
            Please visit our <a href="https://support.sharp-stream.com" target="_blank">Support Portal</a> for more information.
          </p>
        </div>
      </div>
    </template>
    <template slot="body-controls">
      <a :href="radar_base_url" target="_blank" class="btn btn-ss mr-2">
        <i class="flaticon2-analytics-2" />
        <span> Analytics</span>
        <span class="ml-2 badge badge-success">new</span>
      </a>

      <a href="https://support.sharp-stream.com/" class="btn btn-ss" target="_blank">
        Support Portal
      </a>

      <button class="btn btn-ss" @click="complete">
        Close
      </button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from 'VueComponents/VJSModals/VjsModal';
import VjsModalMixin from 'VueComponents/VJSModals/VjsModalMixin';
import RadarMixin from "VueMixins/Analytics/RadarMixin";

export default {
  components: { VjsModal },
  mixins: [VjsModalMixin, RadarMixin],
  props: {
    name: {
      type: String,
      required: false,
      default: `radar-help`,
    },
  },
};
</script>
